const getHardwareConcurrency = (): number => {
    try {
        return parseInt(navigator.hardwareConcurrency as unknown as string);
    } catch (e) {
        return 1;
    }
}

export default getHardwareConcurrency;